import React from 'react';
import { Button } from 'reactstrap';

const ActiveButton = ({ iconClass, onClick, isUpdating, label, color, className, disabled }) => (
  <Button color={color} disabled={disabled || isUpdating} onClick={onClick} className={`btn-brand ${className}`}><i className={iconClass} />{label}</Button>
);

export default ActiveButton;



// WEBPACK FOOTER //
// ./src/components/cms/activeButton/ActiveButton.jsx